import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { FETCH_TICKET_LIST } from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import SupportCard from "./SupportCard";
import HelpAndSupportFooter from "../CommonComponents/HelpAndSupportFooter";
import ErrorMessage from "../CommonComponents/ErrorMessage";
import noTicket from "../../svg/no-ticket.svg";

import api from "../../api/api";

import { removeDuplicates, getUnreadMessage } from "../../helpers";

class SupportMainPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curr_page: 1,
      scrolling: false,
      displayErrorSupport: false,
      unread: 0
    };
  }

  /**
   * function for the tab switch between help topics and support topics
   * takes clicked tab name as argument and switch to selected tab
   * changes the display view and the css of selected tab
   */
  switchTabs = tabName => {
    if (tabName === "help") {
      this.setState({
        switchHelpToSupport: false,
        helpCssClass: "topic-option-help color-fdb100",
        supportCssClass: "topic-option-support color-a5a5a5"
      });
    } else {
      this.setState({
        switchHelpToSupport: true,
        helpCssClass: "topic-option-help color-a5a5a5",
        supportCssClass: "topic-option-support color-fdb100"
      });
    }
  };

  /**
   * this is for history or goback
   * write the work that is should do
   */
  goBack = () => {
    window.open("/faqclose", "_self");
  };

  /**
   * when scrolling start this function is update and load next page
   */

  loadMoreSupport = () => {
    const { userId, userIdv2 } = this.props;
    this.setState(
      {
        scrolling: true,
        displayErrorSupport: false,
        curr_page: this.state.curr_page + 1
      },
      () => {
        if (userIdv2) {
          this.loadSupportMessage(userIdv2);
        } else {
          this.loadSupportMessage(userId);
        }
      }
    );
  };

  /**
   * does the api calls and sends the data to the store
   * it also sets the scrolling to false
   */
  loadSupportMessage = userId => {
    const { helpTS } = this.props;
    if (userId != "" && userId != null) {
      api
        .listOfTickets(this.state.curr_page, userId)
        .then(data => {
          let ticketsData = this.props.supportData.tickets.concat(data.data);
          if (this.props.newTicketAdded) {
            ticketsData = data.data;
          }
          const ticketsSets = removeDuplicates(ticketsData, "id");
          let newSupportData = {
            next_page: data.data.next_page,
            tickets: ticketsSets,
            curr_page: this.state.curr_page
          };
          const unread = getUnreadMessage(ticketsSets, helpTS);

          this.props.listOfSupportTicket(newSupportData);
          this.setState(
            {
              unread,
              scrolling: false
            },
            () => {
              api.displayHideLoader();
            }
          );
        })
        .catch(error => {
          console.log("Error handled here")
          this.setState({
            displayErrorSupport: false,
            scrolling: false,
          }, 
          () => {
            api.displayHideLoader();
          }
        );
          console.log(error);
        });
    } else {
      console.log("Error not handled here")
      this.setState({
        displayErrorSupport: false,
        scrolling: false,
      }, 
      () => {
        api.displayHideLoader();
      }
    );
    }
  };

  /**
   * this method is triggered when loading starts and checks is it end of page or not
   * if end of page then loads more data if it has next page
   */
  scrollSupport = () => {
    const scrolling = this.state.scrolling;
    const pageSupport = this.props.supportData.next_page;

    if (scrolling) {
      return;
    }

    if (pageSupport == null) {
      return;
    }

    const secondLastElement = document.querySelector(".help-support-card-container:nth-last-child(2)");
    const lastOffset = secondLastElement.offsetTop + secondLastElement.clientHeight;
    const pageOffset = window.pageYOffset + window.innerHeight;
    const bottomOffset = 50;
    if (pageOffset > lastOffset - bottomOffset) {
      this.loadMoreSupport();
    }
  };
  /**
   * close the error popup close
   */
  errorCloseCLick() {
    if (this.state.displayErrorSupport) {
      this.setState({
        displayErrorSupport: false,
        scrolling: false
      });
    }
  }

  componentDidMount() {
    const { userId, userIdv2 } = this.props;
    api.displayHideLoader();
    if (this.props.newTicketAdded) {
      api.displayMainLoader();
      if (userIdv2) {
        this.loadSupportMessage(userIdv2);
      } else {
        this.loadSupportMessage(userId);
      }
    }
    this.scrollListner = window.addEventListener("scroll", this.scrollSupport);
  }

  componentWillReceiveProps(nextProps) {
    const { userId, userIdv2 } = nextProps;
    if (userIdv2) {
      if (this.props.newTicketAdded) {
        api.displayMainLoader();
        this.loadSupportMessage(userIdv2);
      }
    } else {
      if (userId) {
        if (this.props.newTicketAdded) {
          api.displayMainLoader();
          this.loadSupportMessage(userId);
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollSupport);
  }
  render() {
    const { helpTS } = this.props;
    const tickets = this.props.supportData && this.props.supportData.tickets;
    const ticketsWithoutReport = tickets.filter(tick => {
      const { tags } = tick;
      const tagsPresent = tags.includes("report-abuse");
      return !tagsPresent;
    });
    const unread = getUnreadMessage(ticketsWithoutReport, helpTS);
    return (
      <div>
        {this.state.displayErrorSupport ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : ""}
        <HelpAndSupportHeader displayMessage={this.props.headerMessage} back={this.goBack.bind(this)} />
        <div className="body-container">
          <div className="topic-option-container">
            <Link to="/" replace className="topic-option-help color-a5a5a5">
              Help Topics
            </Link>
            <div className="topic-option-support color-fdb100">Support Tickets {unread > 0 ? `(${unread})` : null}</div>
          </div>
          {ticketsWithoutReport && ticketsWithoutReport.length > 0 ? (
            <SupportTopics supportData={this.props.supportData} tickets={ticketsWithoutReport} />
          ) : (
            <div className="no-issues">
              <img src={noTicket} />
              <span>No Support Ticket</span>
            </div>
          )}
        </div>
        <HelpAndSupportFooter />
      </div>
    );
  }
}

const SupportTopics = props => {
  return (
    <div className="help-topic-container">
      {props.tickets.map(data => {
        return <SupportCard key={data.id} displayData={data} />;
      })}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    headerMessage: {
      title: "Help And Support",
      description: "Tickets and FAQs",
      backIcon: true,
      moreOptionhidden: true,
      searchOptionHidden: true
    },
    supportData: state.supportData,
    newTicketAdded: state.newTicketAdded,
    userId: state.userId,
    userIdv2: state.userIdv2,
    helpTS: state.helpTS,
    countryCode: state.countryCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    listOfSupportTicket: ticketData => {
      dispatch({
        type: FETCH_TICKET_LIST,
        payload: ticketData
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportMainPage);



// WEBPACK FOOTER //
// ./src/components/Landing/SupportMainPage.js